import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { PenPaperIcon, TrashIcon } from '@/icons';
import { KebabMenu } from '@/shared/components/KebabMenu';
interface FolderCardMenuProps {
  onEdit?: () => void;
  onDelete?: () => void;
}

/** 폴더 카드의 옵션 메뉴(수정·삭제). 카드 전체가 폴더 상세로 가는 링크라 메뉴 조작은 전파를 끊는다. */
export const FolderCardMenu = ({
  onEdit,
  onDelete
}: FolderCardMenuProps) => {
  const {
    t
  } = useTranslation(['common']);
  return <KebabMenu label={t('common:folder.edit.item.menu')} stopPropagation items={[{
    icon: <PenPaperIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} />,
    label: t('global.edit.button'),
    onSelect: () => onEdit?.(),
    disabled: !onEdit
  }, {
    icon: <TrashIcon size={'xs'} fill={ICON_COLOR.default} className={'shrink-0'} />,
    label: t('global.delete'),
    onSelect: () => onDelete?.(),
    disabled: !onDelete
  }]} data-sentry-element="KebabMenu" data-sentry-component="FolderCardMenu" data-sentry-source-file="FolderCardMenu.tsx" />;
};